import Vue from "vue";
import capitalize from "lodash/capitalize";
import isEmpty from "lodash/isEmpty";
import truncate from "lodash/truncate";
import cloneDeep from "lodash/cloneDeep";
import Constant from "@/constants/config/Constant";
import { formatDate } from "@/utils/helpers/dateHelpers";

//formatted date
Vue.filter("formatDate", function (value, formate = "MM/DD/YYYY") {
  if (!value) return value;
  return formatDate(value, formate);
});
//usFormat
Vue.filter("formatPhone", function (value, formate = "US") {
  if (!value) return value;
  if (formate === "US") {
    return (
      "(" +
      value.substring(0, 3) +
      ") " +
      value.substring(3, 6) +
      " " +
      value.substring(6)
    );
  }
});

Vue.filter("fullName", function (value) {
  if (typeof value !== "undefined") {
    if (value.first_name === null && value.last_name === null) {
      return "";
    } else return `${value.first_name} ${value.last_name}`;
  } else return "";
});

Vue.filter("lastName", function (value) {
  if (typeof value !== "undefined") {
    if (value.last_name === null) {
      return "";
    } else return `${value.first_name} ${value.last_name}`;
  } else return "";
});

Vue.filter("concat", function (value, character, userList = false) {
  if (userList) {
    return value
      ?.map((a) => a)
      .sort()
      .join(character);
  }
  return value
    ?.map((a) => a.name)
    .sort()
    .join(character);
});

Vue.filter("maxBirthDate", function (value) {
  value.setDate(value.getDate() - 1);
  return value;
});

Vue.filter("formatId", function (value, idKey) {
  if (!value) return value;
  return value.map((a) => a[idKey]);
});

Vue.filter("capitalize", function (value) {
  return capitalize(value);
});

Vue.filter("isEmpty", function (value) {
  return isEmpty(value);
});

Vue.filter("initials", function (value) {
  if (typeof value === "object") {
    if (value.first_name[0] !== "" && value.last_name !== "")
      return (value.first_name[0] + value.last_name[0]).toUpperCase();
  } else if (typeof value === "string" && value !== "") {
    const splitValue = value.split(" ");
    if (splitValue[1] && splitValue[1][0]) {
      return (splitValue[0][0] + splitValue[1][0]).toUpperCase();
    } else {
      return value.substring(0, 2).toUpperCase();
    }
  }
  return "";
});

Vue.filter("truncate", function (value, length) {
  return truncate(value, { length });
});

Vue.filter("extraAssigne", function (value) {
  const tmpValue = cloneDeep(value).filter((item, index) => {
    if (index) {
      return item;
    }
  });
  return tmpValue.join(", ");
});

Vue.filter("filterDate", function (value, filter) {
  if (
    filter === undefined ||
    filter === null ||
    (typeof filter === "string" && filter.trim() === "")
  ) {
    return true;
  }

  if (value === undefined || value === null) {
    return false;
  }
  return value.split(" ")[0] === formatDate(filter, Constant.DATE_FORMAT_TEXT);
});

Vue.filter("filterDateRange", function (value, filterArray) {
  if (!filterArray) return true;

  const fromDate = filterArray[0];
  const toDate = filterArray[1];

  if (
    fromDate === undefined ||
    fromDate === null ||
    (typeof fromDate === "string" && fromDate.trim() === "")
  ) {
    return true;
  }

  if (fromDate === undefined || fromDate === null) {
    return false;
  }

  if (
    toDate === undefined ||
    toDate === null ||
    (typeof toDate === "string" && toDate.trim() === "")
  ) {
    return true;
  }

  if (toDate === undefined || toDate === null) {
    return false;
  }

  const valueToDate = new Date(value).setHours(0, 0, 0, 0);
  return (
    valueToDate >= fromDate.setHours(0, 0, 0, 0) &&
    valueToDate <= toDate.setHours(0, 0, 0, 0)
  );
});

Vue.filter("filterText", function (value, filter) {
  if (
    filter === undefined ||
    filter === null ||
    (typeof filter === "string" && filter.trim() === "")
  ) {
    return true;
  }

  if (value === undefined || value === null) {
    return false;
  }

  if (filter.length <= 2) {
    return true;
  }
  return value.toUpperCase().indexOf(filter.toUpperCase()) > -1;
});
Vue.filter("filterNumber", function (value, filter) {
  if (
    filter === undefined ||
    filter === null ||
    (typeof filter === "string" && filter.trim() === "")
  ) {
    return true;
  }

  if (value === undefined || value === null) {
    return false;
  }

  return value.toString().toUpperCase() === filter.toUpperCase();
});

Vue.filter("multiselectText", function (value, filter) {
  if (filter === undefined || filter === null) {
    return true;
  }

  if (filter.length === 0) {
    return true;
  }
  console.log(value, filter);
  return value.some((item) => {
    return filter.some((filterItem) => filterItem === item);
  });
});

Vue.filter("filterExtension", function (value) {
  return value.split(".").pop();
});

Vue.filter("currencySymbol", function (currencyCode = "usd") {
  if (!currencyCode && currencyCode === null) return "$";
  if (currencyCode.toLowerCase() === "usd") {
    return "$";
  } else if (currencyCode.toLowerCase() === "aud") {
    return "A$";
  } else if (currencyCode.toLowerCase() === "cad") {
    return "CA$";
  } else if (currencyCode.toLowerCase() === "gbp") {
    return "£";
  }
  //default return usd
  else {
    return "$";
  }
});
